var map = {
	"./agriculture.svg": 6783,
	"./arrow-down-thin.svg": 86760,
	"./arrow-down.svg": 84136,
	"./arrow-down_2.svg": 78175,
	"./arrow-right-big.svg": 58463,
	"./arrow-right-bold.svg": 16854,
	"./ax-alarm.svg": 18803,
	"./ax-archery.svg": 60770,
	"./ax-arrow-bent.svg": 12009,
	"./ax-broken-pipe.svg": 61208,
	"./ax-building.svg": 500,
	"./ax-chemicals.svg": 15071,
	"./ax-crane.svg": 24403,
	"./ax-find-pest.svg": 47350,
	"./ax-groceries.svg": 8097,
	"./ax-hotel-restaurant.svg": 26758,
	"./ax-industry-2.svg": 6223,
	"./ax-list.svg": 49564,
	"./ax-money-2.svg": 97117,
	"./ax-money.svg": 77488,
	"./ax-monitor.svg": 26278,
	"./ax-municipalities.svg": 47416,
	"./ax-thumb-up.svg": 20634,
	"./ax-tractor.svg": 24269,
	"./bird.svg": 70393,
	"./building.svg": 5320,
	"./checkbox.svg": 13099,
	"./checkmark.svg": 1331,
	"./chemicals.svg": 23931,
	"./chemicals2.svg": 30275,
	"./chevron-right.svg": 38696,
	"./circles.svg": 16719,
	"./close.svg": 19972,
	"./cloud.svg": 30795,
	"./download.svg": 59760,
	"./evehicle.svg": 5919,
	"./extinguisher.svg": 37445,
	"./find-mouse.svg": 7387,
	"./fingerprint.svg": 468,
	"./food.svg": 94900,
	"./food_2.svg": 35571,
	"./grid.svg": 85808,
	"./growth.svg": 55613,
	"./handshake.svg": 41259,
	"./heart.svg": 67484,
	"./hotel-restaurant_2.svg": 48569,
	"./house-search.svg": 60273,
	"./industry.svg": 29410,
	"./leaf.svg": 52240,
	"./left-background-pattern-blocks.svg": 69896,
	"./lightbulb.svg": 36153,
	"./link-arrow.svg": 47172,
	"./list.svg": 97128,
	"./logo-symbol.svg": 67778,
	"./logo-symbol_2.svg": 32969,
	"./logotype.svg": 85885,
	"./logotype_2.svg": 51266,
	"./magnifying-glass.svg": 13204,
	"./mouse-bug.svg": 40920,
	"./people.svg": 19777,
	"./phone.svg": 49884,
	"./plus.svg": 13088,
	"./presentation.svg": 61472,
	"./press-release.svg": 5253,
	"./radar.svg": 64540,
	"./recycle.svg": 78439,
	"./report.svg": 10518,
	"./reviewStarEmpty.svg": 75751,
	"./reviewStarFilled.svg": 45644,
	"./right-background-pattern-blocks.svg": 9529,
	"./select-icon.svg": 44170,
	"./shield.svg": 44083,
	"./social-facebook.svg": 11626,
	"./social-instagram.svg": 72062,
	"./social-linkedin.svg": 97360,
	"./social-twitter.svg": 48343,
	"./social-xing.svg": 77638,
	"./social-youtube.svg": 24669,
	"./solid-chevron-right.svg": 72458,
	"./solid-map-marker-alt.svg": 6057,
	"./star.svg": 96960,
	"./tablet-scan.svg": 6778,
	"./ted-gustaf-logo.svg": 4820,
	"./water-drop.svg": 11257,
	"./windows.svg": 75351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;